import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { SwitchViews } from 'src/app/shared/helpers/enums';
import { ModalDirective } from 'src/app/shared/directives/modal.directive';
import { InvestmentCompanyState } from 'src/app/modules/investment-companies/store/investment-company.reducer';
import { UserState } from 'src/app/modules/users/store/user.reducer';
import { KYC, KYCArrayElement } from 'src/app/core/interfaces/shared.interface';

@Component({
  selector: 'app-detail-view-kyc',
  templateUrl: './detail-view-kyc.component.html',
  styles: [
    `
      .last-column-text.last-column-text {
        padding-right: 20px;
      }
    `
  ]
})
export class DetailViewKycComponent implements OnInit, OnDestroy {
  kycArray: KYCArrayElement[];
  subscription: Subscription;
  switchViews = SwitchViews;
  @Input() view: 'user' | 'investmentCompany';
  @Input() modal: ModalDirective;
  @Input() state: Observable<UserState | InvestmentCompanyState>;

  ngOnInit(): void {
    this.subscription = this.state.subscribe((state: UserState | InvestmentCompanyState) => {
      const preparedData = state.kyc.reduce((a: KYCArrayElement[], b: KYC) => {
        const sameQuestionIndex = a.findIndex((kyc: KYC) => kyc.question === b.question);
        if (sameQuestionIndex !== -1) {
          const answers = {
            answers: a[sameQuestionIndex].hasOwnProperty('answers')
              ? a[sameQuestionIndex].answers + `; ${b.answer_text}`
              : a[sameQuestionIndex].answer_text + `; ${b.answer_text}`
          };
          return [...a.slice(0, sameQuestionIndex), Object.assign({}, a[sameQuestionIndex], answers), ...a.slice(sameQuestionIndex + 1)];
        } else {
          return [...a, b];
        }
      }, []);
      this.kycArray = preparedData;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
